import { post, get } from '@api/request';

export const searchQueue = async (
  { queueService },
  authenticationToken,
  { payload },
) => {
  const url = `${queueService}/queue/queue/search`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchSearchOptionNames = async (
  { queueService },
  authenticationToken,
) => {
  const url = `${queueService}/queue/queue/search/options/names`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSearchOptionGroups = async (
  { queueService },
  authenticationToken,
) => {
  const url = `${queueService}/queue/queue/search/options/groups`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSearchOptionWorkItemTypes = async (
  { queueService },
  authenticationToken,
) => {
  const url = `${queueService}/queue/queue/search/options/workitemtypes`;
  const { body } = await get(authenticationToken, url);
  return body;
};
